// extracted by mini-css-extract-plugin
export default {"container":"spinnerModal_container__JIyp0"};